var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"align-center mt-2",staticStyle:{"margin-left":"1px","margin-right":"0"}},[_c('div',{staticClass:"edit-by-content sub-body-regular",domProps:{"innerHTML":_vm._s(_vm.createdContent)}}),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }